'use strict';

if('ontouchstart' in document.documentElement && 'querySelector' in document) {
  var navLinks = document.querySelectorAll('.nav-link');
  [].forEach.call(navLinks, function(link){
    link.classList.add('tap-capable');
  });
}
